<template>
  <img :src="compilationCoverPath" :alt="compilationId" @error="handleError" />
</template>

<script>
import { sizes as thumbSize } from '@shared/enums/ThumbSizesEnum';
import BrandsEnum from '@shared/enums/BrandsEnum.mjs';

import images from '@/assets/images';

export default {
  name: 'CompilationCover',
  props: {
    compilationId: {
      type: String,
      default: ''
    },
    coverSize: {
      type: String,
      default: thumbSize.MEDIUM
    },
    coverFileName: {
      type: String,
      default: ''
    },
    isDefaultCover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      compilationCoverPath: null
    };
  },
  computed: {
    compilationCoverUrl() {
      return this.changedCoverUrl || this.presetCoverUrl;
    },
    changedCoverUrl() {
      return this.$store.getters['CompilationsStore/getCompilationCoverUrl'](
        this.coverFileName
      );
    },
    presetCoverUrl() {
      return this.$store.getters['CompilationsStore/createCoverPath'](
        this.compilationId,
        this.coverSize
      );
    },
    isOcean() {
      const brand = this.$store.getters['ContextStore/brand'];
      return brand === BrandsEnum.OCEAN;
    },
    isOnline() {
      return this.$store.getters['ContextStore/isOnline'];
    }
  },
  watch: {
    async isOnline(val) {
      if (val) {
        this.$_setCompilationCoverPath();
      }
    },
    changedCoverUrl() {
      this.$_setCompilationCoverPath();
    },
    isDefaultCover() {
      this.$_setCompilationCoverPath();
    }
  },
  mounted() {
    this.$_setCompilationCoverPath();
  },
  methods: {
    handleError() {
      const isErrorLoading = true;
      this.$_setCompilationCoverPath(isErrorLoading);
    },
    $_setCompilationCoverPath(isErrorLoading) {
      this.compilationCoverPath = isErrorLoading
        ? this.getBrandCover()
        : this.compilationCoverUrl;
    },
    getBrandCover() {
      if (this.isDefaultCover) {
        return images.compilationDefaultCover;
      }
      return this.isOcean
        ? images.compilationCoverOcean
        : images.compilationCoverFfa;
    }
  }
};
</script>

<style lang="less" src="./CompilationCover.less"></style>
